var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"section__logotype-band align-center justify-start mb-0"},_vm._l((_vm.items),function(logotype,index){return _c('v-col',{key:index,staticClass:"logotype__col d-flex justify-center px-5 flex-grow-0",attrs:{"cols":"12","sm":""}},[_c('v-img',{staticClass:"logotype",attrs:{"eager":"","contain":"","src":logotype.src}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }